<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'"
(click)="windowClick()">
  <dialog-header [label]="'SETTINGS.EXIP_SETTINGS' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
  <mat-card class="display-settings">
    <!-- checkboxes for line and text -->
    <div class="selection-list-title">Acoustic Line Settings</div>
    <mat-selection-list dense style="padding-bottom: 10px">
      <mat-list-option class="selection-list-option" checkboxPosition="before"
        *ngFor="let snsType of acousticElements; index as i" [selected]="acousticElementsOn[i]"
        (click)="onAcousticElemBtnClick(i)">{{snsType}}</mat-list-option>
    </mat-selection-list>

    <!-- color of Selected Acoustic line -->
    <div #AcSelectedColorButton class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onAcSelectedColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorAcSelected()}">color_lens</mat-icon>
        Acoustic Selected Color
      </button>
    </div>

    <!-- color of text -->
    <div #AcTextColorButton class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onAcTextColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorAcText()}">color_lens</mat-icon>
        Acoustic Text Color
      </button>
    </div>

    <!-- Vector Life Time -->
    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
      <span>Acoustic Life Time (Sec)</span>
      <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
        min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="AcousticLifeTime"
        (change)="liftimeVectorSliderChanged($event)">
      </mat-slider>
    </div>
  </mat-card>
</div>